module.exports = __webpack_public_path__ + "img/business_deal.8a0eb380.svg";